import React from 'react'
//styles
import './Item.scss'

const Item = ({data}) => {
  return (
    <div className="c-gantt-item" title={`${data.name} - ${data.secondary_name}`}>
      <span className="c-gantt-item__dot" style={{backgroundColor: data.color}} />
      <div className="ap-ellipsis">
        <span className="ap-typography ap-typography--xxs ap-typography--gray">{data.name}</span>
        {' - '}
        <span className="ap-typography ap-typography--xxs" style={{color: '#1d2331'}}>
          {data.secondary_name}
        </span>
      </div>
    </div>
  )
}

export default Item
